import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const LaborPage = () => {
  return (
    <Layout>
      <PageHero
        title="Labordiagnostik: Ihre Werte direkt vor Ort"
        subtitle="Schnelle und präzise Analyse von Blut, Urin und Stuhl für fundierte Diagnosen."
        backgroundImage="/images/Labordiagnostik_neu.webp"
        ctaText="Labor-Termin buchen"
      />

      <ContentSection
        title="Blutwerte, die Klarheit schaffen"
        content="Unser hauseigenes Labor ermöglicht uns, eine Vielzahl von Untersuchungen an Ihrem Blut, Urin oder Stuhl schnell und effizient durchzuführen. Von Routinekontrollen wie Blutzucker und Cholesterin bis hin zu spezialisierten Tests – wir erhalten zeitnah wichtige Informationen zur Beurteilung Ihrer Gesundheit."
        image="/images/Labordiagnostik_neu.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Laboruntersuchungen in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet schnelle und zuverlässige Labordiagnostik direkt in der Praxis in Diez."
      />

      <CTASection
        title="Benötigen Sie eine Laboruntersuchung?"
        subtitle="Vereinbaren Sie einen Termin für die Blutentnahme oder Abgabe von Proben."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default LaborPage;
